import { render } from "./GeneralLedgerSummary.vue?vue&type=template&id=5be7369a&scoped=true"
import script from "./GeneralLedgerSummary.vue?vue&type=script&lang=js"
export * from "./GeneralLedgerSummary.vue?vue&type=script&lang=js"

import "./GeneralLedgerSummary.vue?vue&type=style&index=0&id=5be7369a&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5be7369a"]])

export default __exports__